<template>
  <div id="app">
    <title-bar-vue class="keep-sticky" />
    <!-- <nav>
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </nav> -->
    <router-view />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import TitleBarVue from "./components/TitleBar.vue";
export default {
  components: {
    TitleBarVue,
  },
  mounted() {
    const keyMap = JSON.parse(window.localStorage.getItem("keymap"));
    if (keyMap) {
      console.log("Using local key map");
      console.log(keyMap);
      this.setKeyMap(keyMap);
    }

    const buttonCompactFlag = window.localStorage.getItem("compactButtons")
    if (buttonCompactFlag) {
      this.setButtonContainerCompactFlag(buttonCompactFlag === "true")
    }
  },
  methods: {
    ...mapActions(["setKeyMap", "setButtonContainerCompactFlag"]),
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Mooli&family=Nunito:wght@400;700&display=swap");

body {
  margin: 0;
}

#app {
  font-family: Nunito, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background-color: #fdfcf6;
  /* background-color: lightcoral; */
  min-height: 100vh;
  min-width: 98vw;
}

.keep-sticky {
  position: sticky;
  top: 0;
  z-index: 100;
}

/*CSS For Toast Notifications*/
.v-toast__text {
  font-family: Nunito, Helvetica, Arial, sans-serif;
}
</style>
